import { render, staticRenderFns } from "./SummaryTab.vue?vue&type=template&id=6378cc9f&scoped=true"
import script from "./SummaryTab.vue?vue&type=script&lang=js"
export * from "./SummaryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6378cc9f",
  null
  
)

export default component.exports